// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const cnp: CountryValidator<"RO", ParsedPersonId> =
  createValidator("ro.cnp", 150);

export default cnp;
export const compact = cnp.compact;
export const format = cnp.format;
export const validate = cnp.validate;
export const generate = (): string =>
  cnp.generate?.() ??
  (() => {
    throw new Error(
      "Validator ro.cnp cannot generate values",
    );
  })();
export const parse = cnp.parse;
